import { FC } from 'react';
import { Divider } from 'antd';
import FlexBox from '../atoms/FlexBox';
import FlexCol from '../atoms/FlexCol';
import { LayoutEditorProvider } from '../../providers/editor/LayoutEditorProvider';
import { useLayoutEditorContext } from '../../providers/editor/LayoutEditorContext';
import { LayoutEditor } from '../editor/LayoutEditor';
import { LayoutEditorToolbar } from '../editor/LayoutEditorToolbar';
import { LayoutEditorDescription } from '../editor/LayoutEditorDescription';
import { PreviewFieldsPicker } from './PreviewFieldsPicker';
import { CompositeFormulaEditor } from './CompositeFormulaEditor';

/** Renders layout editor or details panel based on editor mode. */
const InContextContent: FC = () => {
    const editor = useLayoutEditorContext();

    switch (editor.mode) {
        case 'Layout':
            return <LayoutEditor />;
        case 'Details':
            return (
                <FlexCol>
                    <LayoutEditorDescription />
                    <PreviewFieldsPicker />
                    <CompositeFormulaEditor />
                </FlexCol>
            );
        default:
            return <LayoutEditor />;
    }
};

/** Tab content for editing composite field types: layout structure, preview fields, and formulas. */
export const CompositeFieldEditorTab: FC = () => {
    return (
        <FlexBox column alignStart justifyStart stretch>
            <LayoutEditorProvider type="compositeField">
                <LayoutEditorToolbar />
                <Divider style={{ margin: 0 }} />
                <InContextContent />
            </LayoutEditorProvider>
        </FlexBox>
    );
};
